import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {CompetitionsSliderEntityClickEvent} from "../models/competitions-slider-entity.click-event";

export class CompetitionsSliderEntityClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.entityClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = CompetitionsSliderEntityClickEvent
  }
}
